import { getOptimizedUrl } from '../services/CloudinaryService'
import {
  FILTERS,
  FRAME_COLORS,
  MATERIAL_TYPES,
} from '@mixtiles/web-backend-shared'
import none from './filters/none.webp'
import dramatic from './filters/dramatic.webp'
import noir from './filters/noir.webp'
import silver from './filters/silver.webp'
import vivid from './filters/vivid.webp'
import black from './frames/black.webp'
import white from './frames/white.webp'
import wood from './frames/wood.webp'
import wide_black from './frames/wide_black.webp'
import wide_white from './frames/wide_white.webp'
import red_ash_wood from './frames/red_ash_wood.webp'
import wide_wood from './frames/wide_wood.webp'
import frameNone from './frames/none.webp'
import canvas from './materials/canvas.webp'
import frameless from './materials/frameless.webp'
import sticker from './materials/sticker.webp'
import wide_frame from './materials/wide_frame.webp'
import classicblack from './materials/classic-black.webp'
import earthy_blend from './frames/earthyBlend.webp'
import classic_blend from './frames/clasicBlend.webp'
import harmony_mix from './frames/harmonyMix.webp'

const FILTER_ID_TO_THUMB = {
  [FILTERS.NONE]: none,
  [FILTERS.DRAMATIC]: dramatic,
  [FILTERS.NOIR]: noir,
  [FILTERS.SILVER]: silver,
  [FILTERS.VIVID]: vivid,
}

const COLOR_ID_TO_THUMB = {
  [FRAME_COLORS.BLACK]: black,
  [FRAME_COLORS.WHITE]: white,
  [FRAME_COLORS.WOOD]: wood,
  [FRAME_COLORS.NONE]: frameNone,
}

const WIDE_COLOR_ID_TO_THUMB = {
  [FRAME_COLORS.BLACK]: wide_black,
  [FRAME_COLORS.WHITE]: wide_white,
  [FRAME_COLORS.WOOD]: wide_wood,
  [FRAME_COLORS.RED_ASH_WOOD]: red_ash_wood,
}

const MATERIAL_ID_TO_THUMB = {
  [MATERIAL_TYPES.CANVAS]: canvas,
  [MATERIAL_TYPES.FRAMELESS]: frameless,
  [MATERIAL_TYPES.STICKER]: sticker,
  [MATERIAL_TYPES.WIDE_FRAME]: wide_frame,
  [`${MATERIAL_TYPES.CLASSIC}-${FRAME_COLORS.BLACK}`]: classicblack,
}

export function getCanvas3DAssetUrl() {
  return 'https://res.cloudinary.com/mixtiles/image/upload/v1675760132/assets/canvas/texture/canvas-3d.webp'
}

export function getCanvasTextureAssetUrl() {
  return 'https://res.cloudinary.com/mixtiles/image/upload/v1675760270/assets/canvas/texture/canvas-texture.png'
}

export function getCanvasCropMaskAssetUrl() {
  return 'https://res.cloudinary.com/mixtiles/image/upload/v1675262548/assets/canvas/texture/canvas-crop-mask.svg'
}

export function getColorThumb(color, materialType) {
  const isCanvas = materialType === MATERIAL_TYPES.CANVAS
  let thumb = null
  if (materialType === MATERIAL_TYPES.WIDE_FRAME) {
    thumb = WIDE_COLOR_ID_TO_THUMB[color]
  } else if (isCanvas) {
    thumb = MATERIAL_ID_TO_THUMB[MATERIAL_TYPES.CANVAS]
  } else {
    thumb = COLOR_ID_TO_THUMB[color]
  }

  if (thumb) {
    return thumb
  }

  const assetDirectory =
    materialType === MATERIAL_TYPES.WIDE_FRAME
      ? `assets/frameColor/wideFrame/${color}`
      : `assets/frameColor/${color}`
  return getOptimizedUrl(assetDirectory)
}

export function getPresetThumb(preset) {
  if (preset.configs.length === 1) {
    return getColorThumb(
      preset.configs[0].frameColor,
      preset.configs[0].materialType
    )
  }
  switch (preset.id) {
    case 'classic_blend':
      return classic_blend
    case 'earthy_blend':
      return earthy_blend
    case 'harmony_mix':
      return harmony_mix
    default:
      return null
  }
}

export const getMaterialThumb = (materialType, variant = null) => {
  const materialId = `${materialType}${variant ? `-${variant}` : ''}`
  const thumb = MATERIAL_ID_TO_THUMB[materialId]
  if (thumb) {
    return thumb
  }
  // Fallback to optimized URL
  return getOptimizedUrl(
    `assets/materialIcons/${materialType}${variant ? `-${variant}` : ''}`,
    {
      width: 298,
      height: 184,
    }
  )
}

export const getFilterThumb = (filterId) => FILTER_ID_TO_THUMB[filterId]
